import { optionSchema } from "@/common/schemas/option.schema";
import z from "zod";

export const notificationsConfigurationsSchema = z.record(optionSchema);

export type NotificationsConfigurationsValidationSchema = z.infer<typeof notificationsConfigurationsSchema>
